import { forwardRef, useContext } from "react";
import { useAttribute } from "lib/hooks";
import ContentEditable from "lib/ContentEditable";
import Draggable from "lib/Draggable/Draggable";
import { getNamepath } from "lib/helpers";
import { TreeContext } from "pages/Editor";

function Button({ children, style, path, value }, ref) {
  const [code] = useAttribute("code", false);
  const { tree, editable, context, publish, subscribe } =
    useContext(TreeContext);
  // issue #8
  const [className] = useAttribute("className", false);
  const onClick = () => {
    // issue #4
    if (!editable) {
      const namePath = getNamepath(tree, path);
      if (code) {
        try {
          // eslint-disable-next-line no-new-func
          const action = new Function("return " + code);
          // issue #7
          action()({ publish, subscribe }, namePath);
        } catch (e) {
          console.log(e);
        }
      }
      publish(namePath, "onclick", {});
    }
  };
  const nStyle = { ...style };
  if (context === "preview") {
    nStyle.pointerEvents = "none";
  }
  const props = { className, style: nStyle, onClick };
  // issue #4
  if (context === "preview") {
    return (
      <ContentEditable {...{ path, ref, value: value || children }}>
        <button {...props}></button>
      </ContentEditable>
    );
  } else {
    // TODO: remove draggable
    return (
      <Draggable {...{ path, ref }}>
        <button {...props}>{value || children}</button>
      </Draggable>
    );
  }
}

export default forwardRef(Button);
